export default "__VITE_ASSET__e9acccb2__"